import * as React from "react";
import { forwardRef } from "react";
const SvgGovernance = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1M8 15V1M4 8C4 5.2076 5.63505 2.7971 8 1.67363C10.3649 2.79709 12 5.20762 12 8.00002C12 10.7924 10.3649 13.2029 8 14.3264C5.63505 13.2029 4 10.7924 4 8Z", stroke: "currentColor", strokeWidth: 1.2 }));
const ForwardRef = forwardRef(SvgGovernance);
export default ForwardRef;
